import EyeCrossDark from './EyeCrossDark';

export default EyeCrossDark;
